<template>
  <div class="total vx-row" style="min-width: 125px; width: 100%">
    <vs-button flat color="danger" icon="remove" class="bigger space"
      @click.prevent.stop="change(-1)" :disabled="value === (min || 0)"/>
    <span style=" width: 40px; align-self: center">{{ +value }}</span>
    <vs-button flat color="success" icon="add" class="bigger space"
      @click.prevent.stop="change(1)" :disabled="value === max || disabled"/>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, Boolean],
      default: 0,
    },
    min: { type: Number, },
    max: { type: Number, },
    disabled: { type: Boolean, },
  },
  methods: {
    change (value) {
      const newValue = this.value + value;
      const { min, max, } = this;
      if (newValue < 0 || newValue < min || newValue > max)
        return;
      this.$emit('input', newValue);
    },
  },
  mounted () {
    if (this.value === false)
      this.$emit('input', 0);
    const { min, value, } = this;
    if (value < min)
      this.$emit('input', min);
  },
};
</script>

<style lang="scss" scoped>
  .total {
    flex: 1;
    font-size: 15pt;
    color: black;
    text-align: center;
    font-weight: bold;
    min-width: 100px;
    max-width: 150px;
    user-select: none;
  }
  .bigger {
    font-size: 12pt;
    font-weight: bold;
  }
  .space {
    width: 50px;
  }
</style>
